import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BaseClass<any> implements OnInit {

  constructor(public _common: CommonService,
    public service: WebserviceService,
    public _shared: SharedService) {
      super(document)
     }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  openLogin() {
    // console.log(123);
    
    this._shared.emitLoginModal({ 'login': true });
  }

}
